import { Badge, Box } from '@chakra-ui/react';
import React from 'react';

interface StatusDotProps {
  status: EIntegrityCheckOverallStatus | undefined;
  isRevisionRound?: boolean;
}

export enum EIntegrityCheckOverallStatus {
  GREEN = 2,
  AMBER = 1,
  RED = 0,
  WHITE = 3
}

const StatusLabel: Record<EIntegrityCheckOverallStatus, string> = {
  [EIntegrityCheckOverallStatus.RED]: 'Issue Found',
  [EIntegrityCheckOverallStatus.AMBER]: 'Warning',
  [EIntegrityCheckOverallStatus.GREEN]: 'Done',
  [EIntegrityCheckOverallStatus.WHITE]: 'Awaiting Run'
};

const colorMap: Record<EIntegrityCheckOverallStatus, string> = {
  [EIntegrityCheckOverallStatus.RED]: 'red',
  [EIntegrityCheckOverallStatus.AMBER]: 'orange',
  [EIntegrityCheckOverallStatus.GREEN]: 'green',
  [EIntegrityCheckOverallStatus.WHITE]: 'blue'
};

const StatusDot: React.FC<StatusDotProps> = ({ status, isRevisionRound }) => {
  if (status === undefined) return null;
  const label =
    status === EIntegrityCheckOverallStatus.WHITE && isRevisionRound
      ? 'Skipped'
      : StatusLabel[status];
  const badgeColor =
    status === EIntegrityCheckOverallStatus.WHITE && isRevisionRound
      ? 'gray'
      : colorMap[status];
  return (
    <Badge
      variant="outline"
      lineHeight={'normal'}
      colorScheme={badgeColor}
      size="sm"
      px={3}
      py={1}
    >
      <Box
        w="4"
        h="4"
        bg={badgeColor}
        borderRadius="full"
        display="inline-block"
        border="1px solid"
        mr={2}
        verticalAlign="middle"
      />
      {label}
    </Badge>
  );
};

export default StatusDot;
